'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _modal = require('common/components/modal');

var _modal2 = _interopRequireDefault(_modal);

var _checkPlatform = require('common/utils/check-platform');

var _checkPlatform2 = _interopRequireDefault(_checkPlatform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               *   FixedModal
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               *   Intented to be a drop in replacement for Foundation/Fancybox. Use this instead.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               **/

var FixedModal = function (_Component) {
    _inherits(FixedModal, _Component);

    function FixedModal(props) {
        _classCallCheck(this, FixedModal);

        var _this = _possibleConstructorReturn(this, (FixedModal.__proto__ || Object.getPrototypeOf(FixedModal)).call(this, props));

        _this.state = { hide: false };
        _this.onOverlayClick = _this.onOverlayClick.bind(_this);
        return _this;
    }

    _createClass(FixedModal, [{
        key: 'onOverlayClick',
        value: function onOverlayClick(e) {
            var overlayClass = 'm-common-modal'; // From the inner modal
            var overlayClicked = e.target.classList.contains(overlayClass);
            if (this.props.hideOnOverlayClick && overlayClicked) {
                // TODO this should trigger on ESC keypress too
                this.setState({
                    hide: true
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {

            var style = void 0;
            if (this.state.hide === true) {
                style = { display: 'none' };
            }

            var modalStyle = this.props.modalStyle || {};

            var width = this.props.width;
            var fixedModalClass = 'm-fixed-modal';
            if ((0, _checkPlatform2['default'])() === 'mobile') {
                width = '100%';
                fixedModalClass += ' mobile';
            }

            return _react2['default'].createElement(
                'div',
                { className: fixedModalClass, style: style, onClick: this.onOverlayClick },
                _react2['default'].createElement(
                    _modal2['default'],
                    _extends({}, this.props, { width: width, style: modalStyle, className: this.props.modalClassName }),
                    this.props.children
                )
            );
        }
    }]);

    return FixedModal;
}(_react.Component);

FixedModal.propTypes = {
    'width': _react.PropTypes.number,
    'hideOnOverlayClick': _react.PropTypes.bool
};


module.exports = FixedModal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/fixed-modal/index.jsx
 ** module id = 728
 ** module chunks = 0 1
 **/